import React from 'react';
import Header from './../Components/Header/Header';
import UpdateUserDetails from './Components/UpdateUserDetails';

const MyAccount = () => {
    return (
        <>
            <Header heading="Account Details" subheading="Update your details" icon="user" />
            <div className="container-fluid content">
                <div className="row">
                    <UpdateUserDetails />
                </div>
            </div>
        </>
    );
};

export default MyAccount;